import React, { useState, useEffect } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { theme } from "../../Assets/Theme/theme";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const MultiInputs = ({ label, fontSize, fontWeight, value = [], onChange }) => {
  const [inputs, setInputs] = useState(value.length ? value : [""]);

  useEffect(() => {
    const safeValue = value.length ? value : [""];
    const isDifferent =
      safeValue.length !== inputs.length ||
      safeValue.some((v, i) => v !== inputs[i]);

    if (isDifferent) {
      setInputs(safeValue);
    }
  }, [value]);

  const handleAddInput = () => {
    setInputs((prevInputs) => {
      const updatedInputs = [...prevInputs, ""];
      onChange(updatedInputs);
      return updatedInputs;
    });
  };

  const handleRemoveInput = (index) => {
    setInputs((prevInputs) => {
      const updatedInputs = prevInputs.filter((_, i) => i !== index);
      onChange(updatedInputs);
      return updatedInputs.length ? updatedInputs : [""];
    });
  };

  const handleInputChange = (index, newValue) => {
    setInputs((prevInputs) => {
      const updatedInputs = [...prevInputs];
      updatedInputs[index] = newValue;
      onChange(updatedInputs);
      return updatedInputs;
    });
  };

  const stripHtml = (html) => {
    return html.replace(/<\/?[^>]+(>|$)/g, "");
  };

  return (
    <Box>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 1,
        }}
      >
        <Typography
          variant="body1"
          sx={{
            fontWeight: fontWeight || 500,
            color: theme.colors.text,
            fontSize: fontSize || "16px",
          }}
        >
          {label}
        </Typography>
        <Box sx={{ display: "flex", gap: 1 }}>
          {/* <IconButton onClick={handleAddInput}>
            <Box
              sx={{
                width: "24px",
                height: "24px",
                backgroundColor: theme.colors.orange,
                borderRadius: "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <AddIcon sx={{ color: "#fff" }} />
            </Box>
          </IconButton> */}

          {/* {inputs.length > 1 && (
            <IconButton onClick={() => handleRemoveInput(inputs.length - 1)}>
              <Box
                sx={{
                  width: "24px",
                  height: "24px",
                  backgroundColor: theme.colors.orange,
                  borderRadius: "50%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <RemoveIcon sx={{ color: "#fff" }} />
              </Box>
            </IconButton>
          )} */}
        </Box>
      </Box>

      <Box>
        {inputs.map((inputValue, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              alignItems: "center",
              mb: 2,
            }}
          >
            {index === inputs.length - 1 ? (
              <ReactQuill
                theme="snow"
                value={inputValue}
                style={{ height: "100px", marginBottom: "40px", width: "100%" }}
                onChange={(content) => handleInputChange(index, content)}
              />
            ) : (
              <Typography
                variant="body1"
                sx={{
                  fontWeight: 400,
                  color: theme.colors.text,
                  fontSize: "16px",
                  border: "1px solid #ccc",
                  padding: "8px",
                  borderRadius: "4px",
                  width: "100%",
                  whiteSpace: "pre-wrap",
                  overflow: "hidden",
                  display: "block",
                  paddingLeft: "26px",
                }}
                dangerouslySetInnerHTML={{ __html: inputValue }}
              />

            )}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default MultiInputs;

